<template>
  <!-- main header hub page detail page-->
  <div class="main-container" :class="coverImage ? 'bluesky-header-txt' : ''">
    <div class="header-gradient-spectrum"></div>
    <header class="headerBackgroundImg hub-theme-techno hub-theme-bluesky"
      :style="coverImage !== '' ? `background: ${themeColor} url('${coverImage}');  background-repeat: no-repeat; background-size: cover; -webkit-background-size: cover; -moz-background-size: cover; -o-background-size: cover;  background-position-x: bottom;` : `background: ${themeColor}, `"
      :class="isShort ? 'hub-theme-techno-short hub-theme-bluesky-light' : '', ['HubCourseDetails', 'HubCourseDetails2'].includes($route.name) ? 'p-b-322' : '', coverImage && !isShort ? 'header-text-white' : '', headerShapes ? 'noAfterBeforeShapes' : ''">
      <div class="container py-2 theme-techno-container theme-bluesky-container"
        :class="{ 'expand-article-content': expandContent }">
        <div class="mx-auto col-sm-12">
          <div class="row justify-content-center align-items-center py-3 position-relative zindex-0">
            <div class="col col-sm d-flex align-items-center" :class="isShort ? 'col-sm-6' : 'col-sm-6'"
              v-if="!inIframe">
              <router-link :to="'/' + library_key" class="navbar-brand font-weight-bolder ms-lg-0 text-white">
                <img v-if="siteIcon !== ''" :src="siteIcon !== '' ? siteIcon : '/img/modal_logo.cd169032.png'" alt=""
                  height="50" class="hub-logo-size" />
              </router-link>
              <router-link :to="'/' + library_key">
                <span class="companyname header-txt-col">
                  <template v-if="showHubAgencyName">{{ companyName }} </template>
                </span>
              </router-link>
            </div>

            <div class="col col-sm d-flex align-items-center justify-content-end text-end"
              :class="isShort ? 'col-sm-6' : 'col-sm-6'" v-if="!inIframe">
              <div id="hub-gtranslate" class="d-inline-block text-end align-items-center header-txt-col"><a
                  class="header-homepagelink d-flex me-3" id="modal_gtranslate"></a></div>
              <router-link v-if="$route.name == 'FrontendNews'" :to="'/' + library_key"
                class="header-homepagelink d-inline-block me-3 header-txt-col">Articles</router-link>
              <router-link v-else :to="'/frontendnews/' + library_key"
                class="header-homepagelink d-inline-block me-3 header-txt-col">News</router-link>
              <a v-if="companyName !== '' && websiteUrl !== ''" target="_blank" referrer="noopener" :href="websiteUrl"
                class="header-homepagelink d-inline-block header-txt-col"> Go to {{ companyName }} <i
                  class="fa-regular fa-arrow-up-right-from-square header-txt-col"></i> </a>
            </div>
          </div>
          <div class="search p-0 pt-4 pb-0 d-none" v-if="isShort">
            <div id="hub-search" class="mx-auto theme-techno w-50" v-if="showSearch">
              <div class="d-flex align-items-center" :class="isRTL ? 'me-md-auto' : 'ms-md-auto'">
                <div class="input-group">
                  <input type="search" class="form-control" v-bind:value="searchQuery" ref="searchQuery"
                    v-on:keyup.enter="emitSearchQuery"
                    :placeholder="isRTL ? 'أكتب هنا...' : 'Search for articles...'" />
                  <span class="input-group-text text-body search-glass-icon d-none">
                    <i class="fas fa-search text-black" aria-hidden="true"></i>
                  </span>
                  <button class="text-body submit-keyword-search-icon" @click="emitSearchQueryOnClick">
                    <span class="fw-bold fs-5">Search</span>
                  </button>
                  <button v-if="searchQuery !== ''"
                    class="btn btn-icon-only mb-0 position-absolute end-10 top-50 translate-middle-y btn-search-cat-close"
                    @click="clearSearchQuery">
                    <i class="fas fa-times text-black" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <iframe class="widget-iframe px-0 w-z-index show-iframe bg-white scrollbar-adjust" v-if="isWidgetVisible && isWidgetOpen"
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave"
            id="widget-iframe" :src="widgetBaseURL+'/AdvancedWidget/' + library_key + '?parentURL=' + location"
            frameborder="0"></iframe>

          <div class="position-fixed advanced-widget-btn-wrapper w-auto h-auto w-z-index scrollbar-adjust" v-if="!inIframe">
            <div class="widget-toggle"
              v-if="isWidgetVisible && !['HubCourses', 'HubCourses2', 'HubCourseDetails', 'HubCourseDetails2'].includes($route.name)"
              :style="'background: ' + themeColor" data-container="body" data-animation="true"
              @click="showWidget()">
              <div class="widget-toggle-icon" :class="!isWidgetOpen ? '' : 'd-none'">
                <template v-if="widgetIcon == 'advanced_icon'">
                  <div class="toggle-icon-new-chat">
                    <svg viewBox="0 0 32 32">
                      <path fill="currentColor"
                        d="M12.63,26.46H8.83a6.61,6.61,0,0,1-6.65-6.07,89.05,89.05,0,0,1,0-11.2A6.5,6.5,0,0,1,8.23,3.25a121.62,121.62,0,0,1,15.51,0A6.51,6.51,0,0,1,29.8,9.19a77.53,77.53,0,0,1,0,11.2,6.61,6.61,0,0,1-6.66,6.07H19.48L12.63,31V26.46"
                        class="dotsicon-parent"></path>
                      <path fill="currentColor"
                        d="M19.57,21.68h3.67a2.08,2.08,0,0,0,2.11-1.81,89.86,89.86,0,0,0,0-10.38,1.9,1.9,0,0,0-1.84-1.74,113.15,113.15,0,0,0-15,0A1.9,1.9,0,0,0,6.71,9.49a74.92,74.92,0,0,0-.06,10.38,2,2,0,0,0,2.1,1.81h3.81V26.5Z"
                        class="dotsicon"></path>
                    </svg>
                  </div>
                  <span class="dots-cont">
                    <span class="dot dot-1"></span>
                    <span class="dot dot-2"></span>
                    <span class="dot dot-3"></span>
                  </span>
                </template>
                <i v-if="widgetIcon == 'classic_icon'" class="fa fa-question text-white" style="position: absolute;top: 8px; left: 11px;"></i>
              </div>

              <div class="toggle-up-close" :class="isWidgetOpen ? 'd-block' : ''">
                <i class="fa fa-chevron-down closemetoggle" style="transition: all 0.1s ease 0s" aria-hidden="true">
                </i>
              </div>
            </div>
          </div>
          <div class="search my-4 p-0 pt-4 pb-4 position-relative z-index-1" v-if="!isShort">
            <div class="py-4">
              <h2 class="py-4 text-center h1" :class="coverImage ? 'text-white' : ''" v-if="!inIframe">
                {{ searchHeading !== '' ? searchHeading : 'Hey, what answers do you need?' }}
              </h2>
              <div id="hub-search" class="mx-auto theme-techno w-50 " v-if="showSearch">
                <div class="d-flex align-items-center" :class="isRTL ? 'me-md-auto' : 'ms-md-auto'">
                  <div class="input-group">
                    <input type="search" class="form-control" v-bind:value="searchQuery" ref="searchQuery"
                      v-on:keyup.enter="emitSearchQuery"
                      :placeholder="isRTL ? 'أكتب هنا...' : 'Search for articles...'" />
                    <span class="input-group-text text-body search-glass-icon d-none">
                      <i class="fas fa-search text-black" aria-hidden="true"></i>
                    </span>
                    <button class="text-body submit-keyword-search-icon" @click="emitSearchQueryOnClick">
                      <span class="fw-bold fs-5">Search</span>
                    </button>
                    <button v-if="searchQuery !== ''"
                      class="btn btn-icon-only mb-0 position-absolute end-10 top-50 translate-middle-y btn-search-cat-close"
                      @click="clearSearchQuery">
                      <i class="fas fa-times text-black" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>
<script>
import { projectFirestore } from '../../../firebase/config';
import { useRoute, useRouter } from 'vue-router';
import { ref } from 'vue';
import { useStore } from 'vuex';
import { isPlainObject } from 'lodash';
import { getBaseUrls } from "@/utils/getBaseUrls";

const { widgetBaseURL } = getBaseUrls();

export default {
  name: 'HeaderShortBlueSky',
  setup(props, { emit }) {
    const modal_support_url = 'https://app.modalsupport.com/';
    const route = useRoute();
    const router = useRouter();
    const library_key = ref('');
    const isCustomSubDomain = ref(false);
    const siteIcon = ref('');
    const companyName = ref('');
    const websiteUrl = ref('');
    const searchHeading = ref('');
    const coverImage = ref('');
    const themeColor = ref('');
    const themeColorSpectrum_col_TL = ref('')
    const themeColorSpectrum_col_TR = ref('')
    const themeColorSpectrum_col_C = ref('')
    const themeColorSpectrum_col_BG = ref('')
    const store = useStore();
    const isWidgetVisible = ref(false);
    const showHubAgencyName = ref(true)
    const headerShapes = ref('');
    const widgetIcon = ref('advanced_icon');

    if (window.location.href === modal_support_url) {
      router.push({ name: 'Login' });
    }

    const initData = id => {
      library_key.value = id;
      projectFirestore
        .collection('SupportLibraries')
        .doc(id)
        .get()
        .then(doc => {
          const title = document.getElementById('ogTitle');
          const description = document.getElementById('ogDescription');
          const keywords = document.getElementById('ogKeywords');
          const favicon = document.getElementById('favicon');
          if (doc.exists) {
            // console.log('doc', doc.data().settings);
            if (doc?.data()?.showHubAgencyName !== undefined) {
              showHubAgencyName.value = doc?.data()?.showHubAgencyName
            }
            if (doc.data()?.widgetIcon) {
              widgetIcon.value = doc.data().widgetIcon;
            }
            if (doc.data().settings && doc.data().settings.settings) {
              companyName.value = doc.data().settings.settings.companyName;
              // let url = new URL(doc.data().settings.settings.websiteUrl)
              if (doc.data().settings.settings.websiteUrl) {
                let regex = /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
                if (!regex.test(doc.data().settings.settings.websiteUrl)) {
                  websiteUrl.value = `https://${doc.data().settings.settings.websiteUrl}`;
                } else {
                  websiteUrl.value = doc.data().settings.settings.websiteUrl;
                }
              }

              if (doc.data()?.settings?.settings?.showHubWidget !== undefined) {
                // console.log('doc.data().settings.settings.showHubWidget', doc.data().settings.settings.showHubWidget);
                isWidgetVisible.value = doc.data().settings.settings.showHubWidget;
              } else {
                isWidgetVisible.value = true;
              }
            }

            if (doc.data().settings?.metaData !== undefined && doc.data().settings.metaData.title) {
              if (title) {
                document.title = doc.data().settings.metaData.title;
                title.setAttribute('content', doc.data().settings.metaData.title);
              }
            } else {
              document.title = 'Modal Support';
              title.setAttribute('content', 'Modal Support');
            }
            if (doc.data().settings?.metaData !== undefined && doc.data().settings.metaData.description) {
              if (description) {
                description.setAttribute('href', doc.data().settings.metaData.description);
              }
            }
            if (doc.data().settings?.metaData !== undefined && doc.data().settings.metaData.keywords) {
              if (keywords) {
                keywords.setAttribute('href', doc.data().settings.metaData.description);
              }
            }
            if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.coverImage) {
              coverImage.value = doc.data().publicHelpCenterTheme.coverImage;
            }
            if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.themeColor) {
              themeColor.value = doc.data().publicHelpCenterTheme.themeColor;
            } else {
              themeColor.value = process.env.VUE_APP_DEFAULT_THEME_COLOR;
            }
            if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.themeColorSpectrum_col_TL) {
              themeColorSpectrum_col_TL.value = doc.data().publicHelpCenterTheme.themeColorSpectrum_col_TL
            } else {
              themeColorSpectrum_col_TL.value = process.env.VUE_APP_DEFAULT_THEME_COLOR_SPEC_COL_TL
            }
            if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.themeColorSpectrum_col_TR) {
              themeColorSpectrum_col_TR.value = doc.data().publicHelpCenterTheme.themeColorSpectrum_col_TR
            } else {
              themeColorSpectrum_col_TR.value = process.env.VUE_APP_DEFAULT_THEME_COLOR_SPEC_COL_TR
            }
            if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.themeColorSpectrum_col_C) {
              themeColorSpectrum_col_C.value = doc.data().publicHelpCenterTheme.themeColorSpectrum_col_C
            } else {
              themeColorSpectrum_col_C.value = process.env.VUE_APP_DEFAULT_THEME_COLOR_SPEC_COL_C
            }
            if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.themeColorSpectrum_col_BG) {
              themeColorSpectrum_col_BG.value = doc.data().publicHelpCenterTheme.themeColorSpectrum_col_BG
            } else {
              themeColorSpectrum_col_BG.value = process.env.VUE_APP_DEFAULT_THEME_COLOR_SPEC_COL_BG
            }
            if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.headerShapes) {
              headerShapes.value = doc.data().publicHelpCenterTheme.headerShapes
            }
            if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.siteIcon) {
              siteIcon.value = doc.data().publicHelpCenterTheme.siteIcon;
            }
            if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.favicon) {
              favicon.setAttribute('href', doc.data().publicHelpCenterTheme.favicon);
            } else {
              favicon.setAttribute('href', '/favicon.ico');
            }
            if (doc.data().publicHelpCenterTheme && doc.data().publicHelpCenterTheme.searchHeading !== '') {
              searchHeading.value = doc.data().publicHelpCenterTheme.searchHeading;
            }

            // console.log('themeColor.value', themeColor.value)
            let r = document.querySelector(':root');
            r.style.setProperty('--primaryColor', themeColor.value);
            r.style.setProperty('--primaryColor-hover', themeColor.value + '16');
            r.style.setProperty('--spectrumColorTL', themeColorSpectrum_col_TL.value);
            r.style.setProperty('--spectrumColorTR', themeColorSpectrum_col_TR.value);
            r.style.setProperty('--spectrumColorC', themeColorSpectrum_col_C.value);
            r.style.setProperty('--spectrumColorBG', themeColorSpectrum_col_BG.value);
            r.style.setProperty('--spectrumColorR-hover', themeColorSpectrum_col_TR.value + '90');
            r.style.setProperty('--spectrumColorL-tint', themeColorSpectrum_col_TL.value + '30');
          }
        });
    };

    initData(props.lib_id);

    return {
      library_key,
      siteIcon,
      companyName,
      websiteUrl,
      searchHeading,
      coverImage,
      themeColor,
      themeColorSpectrum_col_TL,
      themeColorSpectrum_col_TR,
      themeColorSpectrum_col_C,
      themeColorSpectrum_col_BG,
      headerShapes,
      isWidgetVisible,
      isFocused: false,
      initData,
      showHubAgencyName,
      widgetBaseURL,
      widgetIcon
    };
  },

  props: ['isShort', 'searchQuery', 'showSearch', 'lib_id', 'inIframe'],
  emits: ['searchQuery', 'library_key', 'isCustomSubDomain'],
  data() {
    return {
      isRTL: false,
      location: document.location.href,
      isWidgetOpen: false,
      expandContent: false,
      listenerAdded:false,
      scrollDisabled: false,
      scrollbarWidth: 0,
    };
  },

  methods: {
    handleMouseEnter() {
      if (!this.scrollDisabled) {
          this.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

          // Prevent layout shift
          document.body.style.overflow = 'hidden';
          document.body.style.paddingRight = `${this.scrollbarWidth}px`;

          // Adjust fixed elements
          document.querySelectorAll('.scrollbar-adjust').forEach(el => {
          const computedRight = window.getComputedStyle(el).right;

          // Save original right if not already saved
          if (!el.dataset.originalRight) {
              el.dataset.originalRight = computedRight;
          }

          // Calculate and set new right
          const originalRight = parseFloat(computedRight || '0');
          el.style.right = `${originalRight + this.scrollbarWidth}px`;
          });

          this.scrollDisabled = true;
      }
    },
    handleMouseLeave() {
      if (this.scrollDisabled) {
          document.body.style.overflow = '';
          document.body.style.paddingRight = '';

          // Restore original right values
          document.querySelectorAll('.scrollbar-adjust').forEach(el => {
          if (el.dataset.originalRight !== undefined) {
              el.style.right = el.dataset.originalRight;
              delete el.dataset.originalRight;
          }
          });

          this.scrollDisabled = false;
      }
    },
    routeTo() {
      let url = '';
      if (this.isCustomSubDomain) {
        url = '/';
      } else {
        url = '/' + this.library_key;
      }
      return url;
    },
    showWidget() {
      // let doc = document.getElementById('widget-iframe');
      // if (doc && !doc.classList.contains('show-iframe')) {
      //   doc.classList.add('show-iframe');
      //   this.isWidgetOpen = true;
      // } else {
      //   doc.classList.remove('show-iframe');
      //   this.isWidgetOpen = false;
      // }
      const iframe = document.getElementById('widget-iframe');
      if (this.isWidgetOpen && iframe && iframe.contentWindow) {
        // Send unload message before closing
        iframe.contentWindow.postMessage({ message: 'widgetUnloaded' }, '*');
      }
      setTimeout(() => {
        this.isWidgetOpen = !this.isWidgetOpen;
      }, 100);
    },
    handleFocus() {
      this.isFocused = true;
    },
    handleBlur() {
      this.isFocused = false;
    },

    emitSearchQuery() {
      const inputValue = this.$refs.searchQuery.value.trimStart();
      this.$emit('searchQuery', inputValue);
    },
    emitSearchQueryOnClick() {
      this.emitSearchQuery();
    },
    clearSearchQuery() {
      this.$refs.searchQuery.value = ''
      const inputValue = this.$refs.searchQuery.value.trimStart();
      this.$emit('searchQuery', inputValue);
    },
    toggleWidgetExpand() {
      // Only add the event listener once
      if (this.listenerAdded) return; // Prevent adding listener multiple times
      window.addEventListener(
        'message',
        function (e) {
          let doc = document.getElementById('widget-iframe');
          const data = e.data;
          if (data.event === 'addCompactClass') {
            document.body.classList.add('compact-widget');
          } else if (data.event === 'removeCompactClass') {
            document.body.classList.remove('compact-widget');
          }

          if (data.event?.type === 'addClassBottomLinks') {
            if (data.event?.noOfLinks) {
              const noOfLinks = data.event.noOfLinks;
              if (noOfLinks >= 1 && noOfLinks <= 10) {
                document.body.classList.add(`bottom-${noOfLinks}-links`);
              }
            }
          }

          // if (data.event?.type === 'removeBottomLinks') {
          //   for (let i = 1; i <= 10; i++) {
          //     document.body.classList.remove(`bottom-${i}-links`);
          //   }
          // }

          if (!doc) {
            return;
          }
          if (data === 'expand') {
            doc.classList.add('expanded-article');
          } else if (data === 'unexpand') {
            doc.classList.remove('expanded-article');
          }
        },
        false
      );
      // Flag to prevent adding the listener multiple times
      this.listenerAdded = true;
    }
  },
  mounted() {
    this.toggleWidgetExpand()
    // window.addEventListener('beforeunload', (e) => {
    //   const iframe = document.getElementById('widget-iframe');
    //   if (iframe && iframe.contentWindow) {
    //     iframe.contentWindow.postMessage({ message: 'widgetUnloaded' }, '*');
    //   }
    // });
  },
  watch: {
    $route() {
    },
    isWidgetOpen() {
      this.toggleWidgetExpand()
    }
  },
};
</script>

<style scoped>
.headerBackgroundImg {
  background-size: cover;
  background-position: 50%;
}

.advanced-widget-btn-wrapper {
  bottom: 40px;
  right: 2%;
  text-align: right;
}

.advanced-widget-btn {
  display: flex;
  padding: 0 !important;
  height: 42px;
  transition: 0.1s;
  width: 42px;
  justify-content: center;
  align-items: center;
}

.expand_iframe {
  width: 800px !important;
  max-height: unset !important;
}

/* Style the clear button for search input */
input[type='search']::-webkit-search-clear-button {
  display: none !important;
}

input[type='search']::-moz-clear {
  display: none !important;
}

input[type='search']::-webkit-search-decoration,
input[type='search']::-webkit-search-cancel-button,
input[type='search']::-webkit-search-clear-button,
input[type='search']::-moz-search-clear-button {
  appearance: none !important;
  display: inline-block !important;
  width: 14px !important;
  height: 14px !important;
  content: '\f00d' !important;
  font-family: 'Font Awesome 5 Free' !important;
  font-weight: 900 !important;
  font-size: 20px !important;
  color: #333 !important;
  cursor: pointer !important;
  opacity: 0 !important;
}

input[type='search']:focus::-webkit-search-decoration,
input[type='search']:focus::-webkit-search-cancel-button,
input[type='search']:focus::-webkit-search-clear-button,
input[type='search']:focus::-moz-search-clear-button {
  opacity: 0.5 !important;
}

.search-component input[type='search']::-webkit-search-clear-button,
.search-component input[type='search']::-moz-clear,
.search-component input[type='search']::-webkit-search-decoration,
.search-component input[type='search']::-webkit-search-cancel-button,
.search-component input[type='search']::-webkit-search-clear-button,
.search-component input[type='search']::-moz-search-clear-button {
  display: none !important;
}

.submit-keyword-search-icon {
  position: relative;
  transition: transform 0.2s;
}

.submit-keyword-search-icon {
  animation: icon-hover 0.5s infinite alternate;
}
@keyframes icon-hover {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(5px);
  }
}

body.g-translate #hub-gtranslate a#modal_gtranslate.header-homepagelink select.goog-te-combo {
  border: 0px solid rgba(255, 255, 255, 0.25) !important;
  background: none !important;
  padding: 3px 10px !important;
  padding-top: 2px !important;
  color: #fff !important;
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.0) !important;
  background-color: var(--primaryColor) !important; 
}
body.g-translate #hub-gtranslate a#modal_gtranslate.header-homepagelink select.goog-te-combo option {
  background: none !important;
  background-color: var(--primaryColor) !important; 
}
body.g-translate #hub-gtranslate a#modal_gtranslate.header-homepagelink  select.goog-te-combo {
  max-width: 160px !important;
  font-size: 11pt !important;
  background: none !important;
  background-color: var(--primaryColor) !important;   
}

body.g-translate header .headcol {
    padding-top: 22px !important;
}

body.g-translate header .headcol {
    padding-top: 22px !important;
}

body.g-translate .mt75 {
    margin-top: 97px !important;
}

body.blueskype-bg .btn-search-cat-close {
  right: 130px !important;
  top: 20px  !important;
}

</style>